// Dev-Note: We need jshint to ignore this file, since it is a third party script.

// jshint ignore: start
ATInternet.Scroll = ATInternet.Scroll || {};
ATInternet.Tracker.Plugins.Scroll = function(parent) {
	var _this = this,
		maxScroll = 0,
        documentHeight = $(document).height(),
        defaultfirst = 25 / 100 * documentHeight,
        defaultinterval = 25 / 100 * documentHeight,
		first,
		interval;

	parent.Scroll = {};

	parent.Scroll.getPageId = function() {
		var page = parent.getContext('page');
		if (page.customVars && page.customVars.site && page.customVars.site['4']) {
			return page.customVars.site['4']
		}
		return null;
	}

	parent.Scroll.stripProtocol = function(url) {
		return url.replace('https://','').replace('http://','');
	}

	parent.Scroll.prepareText = function (text) {
		return encodeURIComponent(text.replace(/&amp;/g,'and').replace(/&/g,'and').replace(/\n/g,' ').replace(/\t+/g,' ').replace(/\s+/g,' '));
	}

	parent.Scroll.sendATHit = function(scrollAT) {
		parent.publisher.send({
			impression: {
				campaignId: '[Scrollview]',
				creation: scrollAT,
				variant: '[' + window.trackingPageSize + ']',
				format : '[' + encodeURIComponent(parent.Scroll.getPageId()) + ']',
				generalPlacement : parent.Scroll.prepareText('[' + document.title + ']'),     
				detailedPlacement : encodeURIComponent('[' + parent.Scroll.stripProtocol(window.location.href) + ']')
			}
		});
	}

	parent.Scroll.init = function(params) {

		if(params) {
			first = parseInt((params.hasOwnProperty('first')) ? params.first : defaultfirst);
			interval = parseInt((params.hasOwnProperty('interval')) ? params.interval : defaultinterval);

			$(document).ready(function () {
			    WordCountScript.Do( function( sValue ){
					window.trackingPageSize = sValue;
					parent.Scroll.sendATHit();
				});
			});


			$(document).scroll(function(e) {
				// grab the scroll amount and the window height
				var scrollAmount = $(window).scrollTop();
				if (scrollAmount < maxScroll) {
					return
				}

				maxScroll = parseInt(scrollAmount + interval);
				// calculate the percentage the user has scrolled down the page
				var scrollPercent = (scrollAmount / documentHeight) * 100;
				var scrollAT = '[' + Math.round(parseInt(scrollPercent / 25) * 25) + '%25]';
				if (scrollAmount > first) {
					parent.Scroll.sendATHit(scrollAT);
				}

			});
		}
	}

};
ATInternet.Tracker.addPlugin('Scroll');
